import type { MouseEvent } from 'react';
import { useRouter } from 'next/router';

import { Button } from '@com/_atoms/NewButton';
import { doctorCardTexts } from '@constant/ocs/doctor';
import { DoctorActivityStatusEnum } from '@models/ocs/doctor';
import { routeList } from '@routes/routeList';

type OcsBookingButtonProps = {
  isLoading?: boolean;
  recId: number;
  activityStatus: number;
  routeLoadingId: number | null;
  setRouteLoadingId: (id: number | null) => void;
  onClick?: () => void;
  dataTestId?: string;
};

const OcsBookingButton = ({
  isLoading,
  recId,
  activityStatus,
  routeLoadingId,
  setRouteLoadingId,
  onClick,
  dataTestId,
}: OcsBookingButtonProps) => {
  const { push } = useRouter();

  const navigateToDoctorProfile = () => {
    push(`${routeList.doctorProfile}/${recId}`);
  };

  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();
    setRouteLoadingId(recId);
    if (onClick) {
      onClick();
      return;
    }
    navigateToDoctorProfile();
  };

  return (
    <Button
      variant="primary"
      size="medium"
      className="w-full !text-Label/Small"
      onClick={handleClick}
      dataTestId={dataTestId}
      disabled={activityStatus !== DoctorActivityStatusEnum.Online}
      isLoading={isLoading || routeLoadingId === recId}
    >
      {doctorCardTexts.booking}
    </Button>
  );
};

export default OcsBookingButton;
